import $http from "../../../../axios-instance";

/**
 * Cargar las versiones de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} state - Estado de la versión de SGA.
 * @param reloadPage - Recargar la página.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function getVersionsSga({ commit, state }, reloadPage = false) {
    commit("dashboard/load", true, { root: true });
    try {
        const {
            page,
            per_page,
            version,
            date_of_publication_from,
            date_of_publication_to,
            is_active,
        } = state.filterVersionsSga;

        const response = await $http.get("sga/version-list", {
            params: {
                page: reloadPage ? 1 : page,
                perPages: per_page,
                search: version,
                date_of_publication_from,
                date_of_publication_to,
                is_active,
            },
        });
        commit("setVersionsSga", response.data.data);
        commit("setPaginateVersionsSga", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Crear una nueva versión de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} version - Versión de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function createVersionSga({ commit }, version) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.post("sga/version-create", version);
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cambiar el estado de la versión de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} id - Identificador de la versión de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function changeStatusVersionSga({ commit }, id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.put(`sga/version-change-status/${id}`);
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Actualizar la versión de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} version - Versión de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function updateVersionSga({ commit }, version) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.put(
            `sga/version-update/${version.id}`,
            version
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar las versiones activas de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function getActiveVersionsSga({ commit }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get("sga/version-list-actives");
        commit("setActiveVersionsSga", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar la versión de SGA segun su id.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} id - Identificador de la versión de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function showVersionSga({ commit }, id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(`sga/version-show/${id}`);
        commit("setVersionSga", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 *  Obtener frases no peligrosas.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @return {Promise<void>}
 * @author Paul Valencia
 */
export async function getSubNotDangers({ commit }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(`sga/sub-not-dangers`);
        commit("setSubsNotDangers", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}